import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-46bba019")

_pushScopeId("data-v-46bba019")
const _hoisted_1 = { class: "md:flex flex-col md:flex-row md:min-h-screen mt-4 mx-4" }
const _hoisted_2 = {
  class: "md:col-span-1 md:grid-cols-1",
  style: {"display":"unset"}
}
const _hoisted_3 = { class: "mx-auto text-white md:col-span-3 md:grid-cols-3 justify-self-center lg:justify-self-stretch" }
const _hoisted_4 = { class: "z-0 text-xl pb-0 font-medium text-bp-dark bg-gray-70 text-center\n     p-5 pt-1" }
const _hoisted_5 = { class: "m-4 mb-2 mt-4 space-y-4" }
const _hoisted_6 = { class: "mt-0 flex justify-center" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "bg-gray-100 p-2 rounded-3xl" }
const _hoisted_9 = { class: "text-center mt-4" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "text-center mt-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_sidebar_profile = _resolveComponent("sidebar-profile")
  const _component_btn_close = _resolveComponent("btn-close")
  const _component_router_link = _resolveComponent("router-link")
  const _component_CheckoutNavBar = _resolveComponent("CheckoutNavBar")
  const _component_PreviewSwiper = _resolveComponent("PreviewSwiper")
  const _component_default_button = _resolveComponent("default-button")
  const _component_input_field = _resolveComponent("input-field")
  const _component_default_card_layout = _resolveComponent("default-card-layout")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_sidebar_profile)
    ]),
    _createVNode("div", _hoisted_3, [
      (_ctx.isAllowedToCloseBoostpack())
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/profile/shared"
          }, {
            default: _withId(() => [
              _createVNode("div", {
                class: "-mr-6 md:-mr-4",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelDialog && _ctx.cancelDialog(...args)))
              }, [
                _createVNode(_component_btn_close)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_default_card_layout, {
        "display-grid": "grid",
        "card-inner-margin": "mt-6 md:mt-0"
      }, {
        default: _withId(() => [
          _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("profile.createBoostpack1.createTitle1")), 1),
          _withDirectives(_createVNode("div", _hoisted_5, [
            _createVNode(_component_CheckoutNavBar, {
              steps: _ctx.steps,
              "current-step": _ctx.activeStep,
              onUpdateStep: _ctx.changeStep
            }, null, 8, ["steps", "current-step", "onUpdateStep"])
          ], 512), [
            [_vShow, _ctx.showHeader]
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, { to: "/profile/shared/publish" })
          ]),
          (_ctx.activeStep === 1)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_PreviewSwiper)
                ]),
                _createVNode("div", _hoisted_9, [
                  _createVNode(_component_default_button, {
                    onClick: _ctx.goToNextStep,
                    "button-text": _ctx.$t('profile.createBoostpack1.btnNext'),
                    "button-width": "w-full"
                  }, null, 8, ["onClick", "button-text"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.activeStep === 2)
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _createVNode(_component_input_field, {
                  "css-class": "",
                  "input-placeholder": _ctx.$t('profile.createBoostpack2.createDetailPlaceholderCategory'),
                  "i-width": "w-full",
                  "input-id": "Category",
                  "required-field": ""
                }, null, 8, ["input-placeholder"]),
                _createVNode(_component_input_field, {
                  "css-class": "",
                  "input-placeholder": _ctx.$t('profile.createBoostpack2.createDetailPlaceholderTitle'),
                  "i-width": "w-full",
                  "input-id": "Title",
                  "required-field": ""
                }, null, 8, ["input-placeholder"]),
                _createVNode(_component_input_field, {
                  "css-class": "",
                  "input-placeholder": _ctx.$t('profile.createBoostpack2.createDetailPlaceholderDescription'),
                  "i-height": "h-32",
                  "i-width": "w-full",
                  "input-id": "Description"
                }, null, 8, ["input-placeholder"]),
                _createVNode("div", _hoisted_11, [
                  _createVNode(_component_router_link, { to: "/profile/shared" }, {
                    default: _withId(() => [
                      _createVNode(_component_default_button, {
                        "button-text": _ctx.$t('profile.createBoostpack2.btnPublish'),
                        "button-width": "w-full"
                      }, null, 8, ["button-text"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
})